/* import __COLOCATED_TEMPLATE__ from './sh-radio.hbs'; */
import clsx from 'clsx';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

const CLASS_NAME = 'sh-radio';
const CLASS_NAME_TABBED = `${CLASS_NAME}--tabbed`;

class ShRadio extends Component {
  @tracked
  tabFocus = false;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.tabFocus && CLASS_NAME_TABBED,
    );
  }

  @action
  handleBlur() {
    if (this.tabFocus) {
      this.tabFocus = false;
    }
  }

  @action
  handleClick(e) {
    e.preventDefault();
    this.args.onclick();
  }

  @action
  handleKeyUp(e) {
    switch (e.keyCode) {
      case 9:
      case 37:
      case 38:
      case 39:
      case 40:
        if (!this.tabFocus) this.tabFocus = true;
        break;
    }
  }
}

export default ShRadio;
